<!-- Universal Banner -->

<template>
	<div class="banner">
		Uni Banner
	</div>
</template>

<script>
export default {

}
</script>

<style scoped>
.banner {
	display: inline-block;
	vertical-align: top;
	width: 110px;
	height: 40px;
	border-radius: 5px;
	border: solid 1px #999;
}
</style>
